import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.scss";
import PopUpOutline from "../PopUpOutline";
import Billboard from "../Billboard";
import ImageButton from "../ImageButton";
import DeviceFrame from "./assets/device_frame.png";
import constants from "../../shared/constants";
import { trapFocus } from "../../shared/utils/index";
import { setLocalStorage } from "../../shared/utils/localStorage";
import storageConstants from "../../shared/constants/storage";
import { useReducers } from "../../shared/hooks/useReducer";

const { REDUCER_TYPE } = constants;
const { HAS_SEEN_ONBOARDING_TUTORIAL } = storageConstants;
const LeftChevron = `${process.env.PUBLIC_URL}/images/Left_Chevron.svg`;
const RightChevron = `${process.env.PUBLIC_URL}/images/Right_Chevron.svg`;
const ClearButton = `${process.env.PUBLIC_URL}/images/cross-icon.svg`;

const WelcomeModal = ({ updatePopUp, showOnboardingTutorial }) => {
  const { provider: appProvider } = useReducers(REDUCER_TYPE.APP);
  const { t: translate } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(null);
  const [wallImgSrc, setWallImgSrc] = useState(null);
  const [slideCount, setSlideCount] = useState(0);
  const onboardingData = appProvider.config.Onboarding_Tutorial_TTVPLUS;

  const modalFocus = useRef(null);
  const [modalElement, setModalElement] = useState([]);
  const onBillboardChange = (index) => {
    setCurrentSlide(onboardingData[index]);
    setSlideCount(index);
  };
  const isLastSlide = currentSlide?.id === onboardingData.length;

  useEffect(() => {
    document.body.style.overflow = "hidden";
    if (onboardingData && onboardingData.length) {
      setCurrentSlide(onboardingData[0]);
    }
    setLocalStorage(HAS_SEEN_ONBOARDING_TUTORIAL, true);

    return () => {
      document.body.style.overflow = "visible";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setModalElement(document.querySelector("#onboardingModal"));
    if (modalElement && modalFocus.current) {
      trapFocus(modalElement);
      modalFocus.current.focus();
    }
  }, [modalElement]);
  useEffect(() => {
    if (currentSlide) {
      let imgUrl = currentSlide.image;
      setWallImgSrc(imgUrl);
    }
    return () => setWallImgSrc(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSlide]);
  const nextSlide = () => {
    setWallImgSrc(null);
    if (slideCount < onboardingData.length) {
      setSlideCount(slideCount + 1);
      setCurrentSlide(onboardingData[slideCount + 1]);
    }
  };
  const prevSlide = () => {
    setWallImgSrc(null);
    if (slideCount >= 1) {
      setSlideCount(slideCount - 1);
      setCurrentSlide(onboardingData[slideCount - 1]);
    }
  };

  return currentSlide ? (
    <React.Fragment>
      <div className="welcome-modal-backdrop"></div>
      <div className="welcome-modal-container" id="onboardingModal">
        <div className="welcome-modal-popup-container">
          <PopUpOutline className="welcome-modal-popup">
            <div className="welcome-slide-container">
              <span className="close-modal">
                <ImageButton src={ClearButton} alt="" onClickHandler={() => updatePopUp()} ref={modalFocus} />
              </span>
              {currentSlide.image && (
                <div className="left-chevron">
                  {currentSlide.id > 1 && (
                    <ImageButton src={LeftChevron} alt="LeftChevron" onClickHandler={() => prevSlide()} />
                  )}
                </div>
              )}
              {currentSlide.image && (
                <div className="welcome-item">
                  <div className="Welcome-item-image">
                    <div className="carousel-image">
                      {(currentSlide.id === 2 || currentSlide.id === 3) && (
                        <img
                          src={DeviceFrame}
                          alt=""
                          data-testid="thumbnail"
                          className="thumbnail-border"
                          width="100%"
                          height="100%"
                        />
                      )}
                      {wallImgSrc && (
                        <img
                          src={process.env.PUBLIC_URL + wallImgSrc}
                          alt=""
                          data-testid="thumbnail"
                          className="thumbnail"
                          width="100%"
                          height="100%"
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
              {currentSlide.image && !isLastSlide && (
                <div className="right-chevron">
                  <ImageButton src={RightChevron} alt="RightChevron" onClickHandler={() => nextSlide(slideCount)} />
                </div>
              )}
            </div>
            <div className="welcome-slide-title-container">
              <div>
                <div>
                  <div className={"welcome-popup-title"}>{translate(currentSlide.title)}</div>
                  <div className="welcome-popup-subtitle">
                    {translate(currentSlide.subTitle_1)} <br /> {translate(currentSlide.subTitle_2)}
                  </div>
                </div>
                <div>
                  {currentSlide.image && (
                    <Billboard
                      noOfItems={onboardingData.length}
                      onChange={onBillboardChange}
                      onBoardingPopup={true}
                      selectedDot={slideCount}
                    />
                  )}
                </div>
              </div>
            </div>
          </PopUpOutline>
        </div>
      </div>
    </React.Fragment>
  ) : null;
};
export default WelcomeModal;
